module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete":"Delete?"},"es":{"delete":"Eliminar?"},"sw":{"delete":"Futa?"}}')
  delete Component.options._Ctor
}
